// This is just an example,
// so you can safely delete all default props below

export default {
    text_inactive_header: 'Automatic logout',
    text_inactive_message1: 'Due to inactivity, you will be automatically logged out in',
    text_inactive_message2: 'seconds.',
    text_inactive_message3: 'Do you want to stay logged in?',
    text_auto_signed_out_title: 'Logged out due to inactivity',
    text_auto_signed_out_description: 'You are logged out due to inactivity.',
}
